import { useEffect, useState } from "react";
import fetchProduct from "./fetchProduct";

/**
 *
 * @param ids [gid] product ids `gid://shopify/Product/12345`
 * @returns [data] Object of products by GID
 */
export default function useProducts(ids, queryType = "id") {
  const [data, setData] = useState(null);
  const idsString = ids.join(",");

  useEffect(() => {
    if (!ids.length) return;

    Promise.all(ids.map((id) => fetchProduct(id, queryType))).then(
      (products) => {
        setData(products);
      },
    );
  }, [idsString, setData]);

  return data || [];
}
